import { AppNavigationItem } from '../models/app-navigation-item.model';

export const userNavigationItems: Array<AppNavigationItem> = [
  {
    label: 'My Account',
    path: '/account',
    permissions: [],
  },
  {
    label: 'Log Out',
    path: '/logout',
    permissions: [],
  },
];
